import { render, staticRenderFns } from "./ReceiptManage.vue?vue&type=template&id=1fc63a56&scoped=true&"
import script from "./ReceiptManage.vue?vue&type=script&lang=js&"
export * from "./ReceiptManage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptManage.vue?vue&type=style&index=0&id=1fc63a56&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1fc63a56",
  null
  
)

export default component.exports